import { useEffect, useRef, useState } from 'react';
import Schedule from '../../../component/schedule/Schedule';
import SelectionBox from '../../../component/SelectionBox';
import CodeUtil from '../../../util/CodeUtil';
import BreadCrumb from '../../../component/BreadCrumb';
import ModalRef from '../../../component/ModalRef';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { VIEW_ENROLMENT_SCHEDULE_TABLE } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import PopupRef from '../../../component/PopupRef';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import { CODE_GROUP_ID, ROLE, SEMESTER_STUDENT_ENROLMENT_CHECK_PATH } from '../../../constant/Constant';
import { useLocation, useNavigate } from 'react-router-dom';
import qs from 'qs';

const EnrolmentScheduleTableView = () => {
    const [semesterId, setSemesterId] = useState(SessionStorageUtil.getCurrentSemesterId());
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const scheduleRef = useRef(null);
    const userRoleCd = AuthenticationUtil.getUserRoleCd();
    const [userId, setUserId] = useState();
    const [userNm, setUserNm] = useState();
    const [userUniversityNm, setUserUniversityNm] = useState();

    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        let userId = '';
        if (userRoleCd != ROLE.STUDENT) {
            userId = queryData.userId;
            setUserId(userId);
            setUserNm(queryData.userNm);
            setUserUniversityNm(CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, queryData.userUniversityCd));
        } else {
            userId = AuthenticationUtil.getUserId();
            setUserId(userId);
        }
        scheduleRef.current.search(semesterId, userId);
    }, []);

    const onClick = () => {
        scheduleRef.current.search(semesterId, userId);
    };

    const goBack = () => {
        navigate(SEMESTER_STUDENT_ENROLMENT_CHECK_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg01'>
                    <h2 className='con-title'>
                        {userRoleCd == ROLE.STUDENT ? VIEW_ENROLMENT_SCHEDULE_TABLE.title : '교직원 시간표 확인'}
                    </h2>
                    <p className='con-title-p'>
                        {userRoleCd == ROLE.STUDENT
                            ? VIEW_ENROLMENT_SCHEDULE_TABLE.subTitle
                            : '교직원이 학생들의 시간표를 확인하기 위해 사용합니다'}
                    </p>
                </div>
                {userRoleCd == ROLE.STUDENT ? (
                    <div className='sub-nav-wrap'>
                        <BreadCrumb />
                    </div>
                ) : (
                    <div className='user-form-wrap '>
                        <div className='user-form-inner '>
                            <div className='form-space-between'>
                                <div className='form-row'>
                                    <div className='form'>
                                        <div className='text-info'>시간표 확인 대상</div>
                                    </div>
                                    <div className='form'>
                                        <div className='text-normal'>{userUniversityNm}</div>
                                    </div>

                                    <div className='form'>
                                        <div className='text-strong'>
                                            {userNm} ({userId})
                                        </div>
                                    </div>
                                </div>
                                <div className='navi-button'>
                                    <button type='button' className='btn blue-border' onClick={() => goBack()}>
                                        목록보기
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                <div className='con-form-wrap'>
                    <div className='board-inner pd30'>
                        <div className='board-row'>
                            <div className='lec-check-box'>
                                <div className='form-box-container'>
                                    <SelectionBox
                                        title='학기'
                                        value={semesterId}
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                        onChange={(e) => setSemesterId(e.target.value)}
                                        useAll={false}
                                    />
                                </div>
                                <div className='lec-check-btn'>
                                    <SearchButtonBox title='조회' onClick={(e) => onClick()} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='con-tb-wrap appli-result-wrap'>
                    <div className='con-tb-title'>
                        <h3 className='tb-tit-name'>수강 시간표</h3>
                    </div>
                    <div className='apply-step-inner'>
                        <ul className='explain-txt'>
                            <li>
                                회색 일정은 혁신융합대학사업(미래자동차)의 수강신청을 통해 추가된 수강시간표로 수정이
                                불가합니다.
                            </li>
                            <li>하늘색 일정은 개인이 등록한 개인별 수강 일정으로 등록/수정/삭제가 가능합니다.</li>
                            <li>
                                개인일정은 시작시간을 클릭 후 드래그하여 30분 이상 선택하여 추가할 수 있습니다. 등록된
                                일정은 더블클릭하여 수정하거나 드래그와 크기 조절으로 시간수정이 가능합니다.
                            </li>
                        </ul>
                    </div>
                    <div className='con-time-table'>
                        {/* <div className='lecture-table-wrap'> */}
                        <Schedule
                            semesterId={semesterId}
                            userId={userId}
                            popupRef={popupRef}
                            modalRef={modalRef}
                            ref={scheduleRef}
                        />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default EnrolmentScheduleTableView;
